import Hero from "@/pages/home/components/Hero";
import CategorySection from "@/pages/home/components/CategorySection";
import MangaGridSection from "@/pages/home/components/MangaGridSection";
import RankingSection from "@/pages/home/components/RankingSection";
import FaqSection from "@/pages/home/components/FaqSection";
import CtaSection from "@/pages/home/components/CtaSection";
import useSeo from "@/hooks/useSeo";
import JsonLd from "@/components/common/JsonLd";
import { hotList, completedList, newList, topRanked } from "@/mocks/manga";

export default function Home() {
  useSeo({
    title: "",
    description:
      "91漫画提供海量免费漫画在线阅读，分类浏览与人气榜、热门推荐、完结榜、新作一网打尽，帮你快速找到想看的漫画。",
    keywords: "91漫画,91漫画分类,91漫画人气榜,91漫画排行,91漫画热门推荐,91漫画完结榜,91漫画新作",
    path: "/",
  });

  return (
    <>
      <JsonLd
        data={{
          "@context": "https://schema.org",
          "@type": "WebPage",
          name: "91漫画",
          url: "https://zhuanpan91.github.io/",
          description: "海量免费漫画在线阅读平台，分类浏览、人气榜、热门推荐、完结榜与新作。",
          inLanguage: "zh-CN",
        }}
      />
      <JsonLd
        data={{
          "@context": "https://schema.org",
          "@type": "ItemList",
          name: "91漫画热门推荐",
          itemListElement: hotList.map((m, i) => ({
            "@type": "ListItem",
            position: i + 1,
            name: m.title,
            url: `https://zhuanpan91.github.io/article/${m.id}`,
          })),
        }}
      />
      <JsonLd
        data={{
          "@context": "https://schema.org",
          "@type": "ItemList",
          name: "91漫画人气榜",
          itemListElement: topRanked.map((m, i) => ({
            "@type": "ListItem",
            position: i + 1,
            name: m.title,
            url: `https://zhuanpan91.github.io/article/${m.id}`,
          })),
        }}
      />

      <Hero />
      <CategorySection />
      <MangaGridSection
        title="热门推荐"
        subtitle="编辑精选，值得一读的人气好漫画"
        moreTo="/category/hot"
        icon="ri-star-smile-fill"
        items={hotList}
      />
      <RankingSection />
      <MangaGridSection
        title="完结榜"
        subtitle="一口气看完的完整佳作"
        moreTo="/category/completed"
        icon="ri-check-double-line"
        items={completedList}
      />
      <MangaGridSection
        title="新作"
        subtitle="最新上架，抢先追更的精彩漫画"
        moreTo="/category/new"
        icon="ri-sparkling-2-line"
        items={newList}
      />
      <FaqSection />
      <CtaSection />
    </>
  );
}